<template>
    <div>
        <p>上传压缩包，将压缩包解压到指定的文件夹</p>
        <el-input placeholder="输入文件解压后存放的地址,默认为public文件夹，不要输public,只用输public后的文件夹位置" v-model="path" clearable>
        </el-input>
        <el-checkbox v-model="ifcover">是否清空覆盖原文件夹内容</el-checkbox>
      <el-upload
        drag
        :on-change="handlechange"
        :file-list="filelist"
        :auto-upload="false"
        :multiple="false"
        action
      >
        <i class="el-icon-upload"></i>
        <div style="color:red;" slot="tip">
          <p>只能上传.zip的压缩包</p>
        </div>
      </el-upload>

      <el-button type="primary" style="width:50%" v-if="filelist.length>0" @click="submit">上传</el-button>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        ifcover:false,
        path:'',
        filelist: [],
        formdata: new FormData()
      };
    },
    methods: {
      handlechange(file, filelist) {
        let filetype = file.name.slice(
          file.name.indexOf(".") + 1,
          file.name.length
        );
        if (filetype != "zip") {
          this.$message("文件格式必须为zip");
          return false;
        }
        this.filelist = filelist.slice(-1); //只允许上传一个
        this.formdata.append("path",this.path)
        this.formdata.append("ifcover",this.ifcover)
        this.formdata.append("zip", file.raw);
      },
      submit() {
  
          this.$axios({
          method: "post",
          url: url + "zipfiletofolder",
          data: this.formdata,
          config: { headers: { "Content-Type": "multipart/form-data" } }
        }).then(res => {
          this.$message("上传成功");
          this.filelist = [];
          this.formdata = new FormData();
        });
  
      }
    }
  };
  </script>


// WEBPACK FOOTER //
// src/components/exceltodb/touploadzipfile.vue